// // ProfileLayout.js - Main Profile Layout Component using existing implementation
// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { useAuth } from "../../Utility/AuthProvider";
// import APICall from "../../Utility/APICall"; // Your existing API call function
// import { paths } from "../../Utility/Constants"; // Your existing paths
// import Cookies from "js-cookie"; // Your existing cookie library

// // Profile option component
// const ProfileOption = ({
//   icon,
//   title,
//   description,
//   onClick,
//   showChevron = true,
// }) => {
//   return (
//     <button
//       onClick={onClick}
//       className="w-full flex items-center justify-between p-4 hover:bg-gray-50 rounded-lg transition-colors group"
//     >
//       <div className="flex items-center space-x-4">
//         <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center text-blue-600">
//           {icon}
//         </div>
//         <div className="text-left">
//           <h3 className="text-base font-medium text-gray-900">{title}</h3>
//           {description && (
//             <p className="text-sm text-gray-500">{description}</p>
//           )}
//         </div>
//       </div>
//       {showChevron && (
//         <svg
//           className="w-5 h-5 text-gray-400 group-hover:text-gray-600"
//           fill="none"
//           stroke="currentColor"
//           viewBox="0 0 24 24"
//         >
//           <path
//             strokeLinecap="round"
//             strokeLinejoin="round"
//             strokeWidth={2}
//             d="M9 5l7 7-7 7"
//           />
//         </svg>
//       )}
//     </button>
//   );
// };

// // KYC Status Component
// const KYCStatusCard = ({ status = "pending" }) => {
//   const statusConfig = {
//     pending: {
//       title: "Your payout settings are pending",
//       description: "Complete to start receiving payments",
//       bgColor: "bg-yellow-500",
//       textColor: "text-white",
//       icon: (
//         <svg
//           className="w-6 h-6"
//           fill="none"
//           stroke="currentColor"
//           viewBox="0 0 24 24"
//         >
//           <path
//             strokeLinecap="round"
//             strokeLinejoin="round"
//             strokeWidth={2}
//             d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
//           />
//         </svg>
//       ),
//     },
//     "in-process": {
//       title: "KYC verification under process...",
//       description: "We'll update you when it's done",
//       bgColor: "bg-blue-500",
//       textColor: "text-white",
//       icon: (
//         <svg
//           className="w-6 h-6"
//           fill="none"
//           stroke="currentColor"
//           viewBox="0 0 24 24"
//         >
//           <path
//             strokeLinecap="round"
//             strokeLinejoin="round"
//             strokeWidth={2}
//             d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
//           />
//         </svg>
//       ),
//     },
//     complete: {
//       title: "KYC verification complete",
//       description: "You can now receive payments",
//       bgColor: "bg-green-500",
//       textColor: "text-white",
//       icon: (
//         <svg
//           className="w-6 h-6"
//           fill="none"
//           stroke="currentColor"
//           viewBox="0 0 24 24"
//         >
//           <path
//             strokeLinecap="round"
//             strokeLinejoin="round"
//             strokeWidth={2}
//             d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
//           />
//         </svg>
//       ),
//     },
//     failed: {
//       title: "KYC verification failed",
//       description: "Please resubmit the documents to try again.",
//       bgColor: "bg-red-500",
//       textColor: "text-white",
//       icon: (
//         <svg
//           className="w-6 h-6"
//           fill="none"
//           stroke="currentColor"
//           viewBox="0 0 24 24"
//         >
//           <path
//             strokeLinecap="round"
//             strokeLinejoin="round"
//             strokeWidth={2}
//             d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
//           />
//         </svg>
//       ),
//     },
//   };

//   const config = statusConfig[status];

//   return (
//     <div
//       className={`${config.bgColor} ${config.textColor} rounded-lg p-4 flex items-start justify-between`}
//     >
//       <div className="flex-1">
//         <h3 className="font-semibold text-lg mb-1">{config.title}</h3>
//         <p className="text-sm opacity-90">{config.description}</p>
//       </div>
//       <div className="ml-4">{config.icon}</div>
//     </div>
//   );
// };

// // Main Profile Layout Component
// const ProfileLayout = () => {
//   const navigate = useNavigate();
//   const { user, jwt, deleteSession } = useAuth(); // Use your existing auth provider
//   const [kycStatus, setKycStatus] = useState("pending"); // pending, in-process, complete, failed
//   const [kycData, setKycData] = useState(null);
//   const [isLoading, setIsLoading] = useState(false);

//   // Fetch KYC status using your existing API
//   const fetchKYCStatus = async () => {
//     try {
//       setIsLoading(true);
//       const response = await APICall(
//         "GET",
//         paths.user.kycStatus,
//         undefined,
//         undefined,
//         jwt
//       );

//       if (response && response.status === "success") {
//         setKycData(response);
//         setKycStatus(response.kyc_status || "pending");
//       }
//     } catch (error) {
//       console.error("Error fetching KYC status:", error);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (jwt && user) {
//       fetchKYCStatus();
//     }
//   }, [jwt, user]);

//   const handleEditProfile = () => {
//     navigate("/profile/edit");
//   };

//   const handleAccountPress = () => {
//     navigate("/profile/account");
//   };

//   const handleNotificationPress = () => {
//     navigate("/profile/notifications");
//   };

//   const handleSettingsPress = () => {
//     navigate("/profile/settings");
//   };

//   const handleHelpSupportPress = () => {
//     navigate("/profile/help-support");
//   };

//   const handlePaymentPress = () => {
//     navigate("/profile/payments");
//   };

//   const handlePrivacyPolicyPress = () => {
//     navigate("/profile/privacy-policy");
//   };

//   const handleTermsConditionsPress = () => {
//     navigate("/profile/terms-conditions");
//   };

//   const handleLogout = async () => {
//     try {
//       setIsLoading(true);

//       // Use your existing APICall pattern for logout
//       const response = await APICall(
//         "PUT",
//         paths.user.logout,
//         user?.entity_id,
//         undefined,
//         jwt
//       );

//       if (response && response.status === "success") {
//         // Clear cookies using js-cookie (matching your existing pattern)
//         Cookies.remove("jwtToken", { path: "/" });
//         Cookies.remove("user_entity_id", { path: "/" });
//         Cookies.remove("appSettings", { path: "/" });

//         // Use your existing deleteSession function
//         deleteSession();

//         // Clear localStorage if needed
//         localStorage.clear();

//         // Navigate to auth page
//         navigate("/auth");
//       } else {
//         throw new Error(response?.message || "Logout failed");
//       }
//     } catch (error) {
//       console.error("Logout error:", error);
//       // You might want to show an error toast here
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   return (
//     <div className="min-h-screen bg-gray-50">
//       <div className="max-w-4xl mx-auto">
//         {/* Header Section */}
//         <div className="bg-white rounded-lg shadow-sm mb-6 p-6">
//           {/* User Profile Section */}
//           <div className="bg-blue-600 rounded-lg p-6 mb-4">
//             <div className="flex items-center justify-between">
//               <div className="flex items-center space-x-4">
//                 <div className="w-16 h-16 rounded-full bg-white/20 flex items-center justify-center overflow-hidden">
//                   {user?.media?.profile_picture?.location ? (
//                     <img
//                       src={user.media.profile_picture.location}
//                       alt="Profile"
//                       className="w-full h-full object-cover"
//                     />
//                   ) : (
//                     <svg
//                       className="w-8 h-8 text-white"
//                       fill="none"
//                       stroke="currentColor"
//                       viewBox="0 0 24 24"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
//                       />
//                     </svg>
//                   )}
//                 </div>
//                 <div className="text-white">
//                   <h2 className="text-xl font-semibold">
//                     {user?.first_name} {user?.last_name}
//                   </h2>
//                   <p className="text-blue-100">{user?.mobile}</p>
//                 </div>
//               </div>
//               <button
//                 onClick={handleEditProfile}
//                 className="px-4 py-2 border border-white/30 rounded-full text-white text-sm hover:bg-white/10 transition-colors"
//               >
//                 Edit
//               </button>
//             </div>
//           </div>

//           {/* KYC Status Card */}
//           <KYCStatusCard status={kycStatus} />
//         </div>

//         {/* Menu Options */}
//         <div className="bg-white rounded-lg shadow-sm mb-6">
//           <div className="p-6 space-y-2">
//             <ProfileOption
//               icon={
//                 <svg
//                   className="w-5 h-5"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
//                   />
//                 </svg>
//               }
//               title="Account"
//               onClick={handleAccountPress}
//             />

//             <ProfileOption
//               icon={
//                 <svg
//                   className="w-5 h-5"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M15 17h5l-5 5v-5zM9 9v6m0 0v6m0-6h6m6 0a9 9 0 11-18 0 9 9 0 0118 0z"
//                   />
//                 </svg>
//               }
//               title="Notifications"
//               onClick={handleNotificationPress}
//             />

//             <ProfileOption
//               icon={
//                 <svg
//                   className="w-5 h-5"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
//                   />
//                 </svg>
//               }
//               title="Payments"
//               onClick={handlePaymentPress}
//             />

//             <ProfileOption
//               icon={
//                 <svg
//                   className="w-5 h-5"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
//                   />
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
//                   />
//                 </svg>
//               }
//               title="Settings"
//               onClick={handleSettingsPress}
//             />

//             <ProfileOption
//               icon={
//                 <svg
//                   className="w-5 h-5"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
//                   />
//                 </svg>
//               }
//               title="Help & Support"
//               onClick={handleHelpSupportPress}
//             />
//           </div>
//         </div>

//         {/* Footer Section */}
//         <div className="bg-white rounded-lg shadow-sm p-6 space-y-4">
//           <button
//             onClick={handlePrivacyPolicyPress}
//             className="block w-full text-left text-gray-600 hover:text-gray-900 py-2"
//           >
//             Privacy Policy
//           </button>

//           <button
//             onClick={handleTermsConditionsPress}
//             className="block w-full text-left text-gray-600 hover:text-gray-900 py-2"
//           >
//             Terms & Conditions
//           </button>

//           <div className="flex items-center justify-between pt-4 border-t border-gray-200">
//             <button
//               onClick={handleLogout}
//               disabled={isLoading}
//               className="text-red-600 hover:text-red-700 font-medium disabled:opacity-50"
//             >
//               {isLoading ? "Logging out..." : "Logout"}
//             </button>
//             <span className="text-sm text-gray-500">App Version: 1.0.0</span>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ProfileLayout;

// ProfileLayout.js - Main Profile Layout Component using existing implementation
// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { useAuth } from "../../Utility/AuthProvider"; // Your existing auth provider
// import APICall from "../../Utility/APICall"; // Your existing API call function
// import { paths } from "../../Utility/Constants"; // Your existing paths
// import Cookies from "js-cookie"; // Your existing cookie library

// // Profile option component
// const ProfileOption = ({
//   icon,
//   title,
//   description,
//   onClick,
//   showChevron = true,
// }) => {
//   return (
//     <button
//       onClick={onClick}
//       className="w-full flex items-center justify-between p-4 hover:bg-gray-50 rounded-lg transition-colors group"
//     >
//       <div className="flex items-center space-x-4">
//         <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center text-blue-600">
//           {icon}
//         </div>
//         <div className="text-left">
//           <h3 className="text-base font-medium text-gray-900">{title}</h3>
//           {description && (
//             <p className="text-sm text-gray-500">{description}</p>
//           )}
//         </div>
//       </div>
//       {showChevron && (
//         <svg
//           className="w-5 h-5 text-gray-400 group-hover:text-gray-600"
//           fill="none"
//           stroke="currentColor"
//           viewBox="0 0 24 24"
//         >
//           <path
//             strokeLinecap="round"
//             strokeLinejoin="round"
//             strokeWidth={2}
//             d="M9 5l7 7-7 7"
//           />
//         </svg>
//       )}
//     </button>
//   );
// };

// // KYC Status Component
// const KYCStatusCard = ({ status = "pending" }) => {
//   const statusConfig = {
//     pending: {
//       title: "Your payout settings are pending",
//       description: "Complete to start receiving payments",
//       bgColor: "bg-yellow-500",
//       textColor: "text-white",
//       icon: (
//         <svg
//           className="w-6 h-6"
//           fill="none"
//           stroke="currentColor"
//           viewBox="0 0 24 24"
//         >
//           <path
//             strokeLinecap="round"
//             strokeLinejoin="round"
//             strokeWidth={2}
//             d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
//           />
//         </svg>
//       ),
//     },
//     "in-process": {
//       title: "KYC verification under process...",
//       description: "We'll update you when it's done",
//       bgColor: "bg-blue-500",
//       textColor: "text-white",
//       icon: (
//         <svg
//           className="w-6 h-6"
//           fill="none"
//           stroke="currentColor"
//           viewBox="0 0 24 24"
//         >
//           <path
//             strokeLinecap="round"
//             strokeLinejoin="round"
//             strokeWidth={2}
//             d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
//           />
//         </svg>
//       ),
//     },
//     complete: {
//       title: "KYC verification complete",
//       description: "You can now receive payments",
//       bgColor: "bg-green-500",
//       textColor: "text-white",
//       icon: (
//         <svg
//           className="w-6 h-6"
//           fill="none"
//           stroke="currentColor"
//           viewBox="0 0 24 24"
//         >
//           <path
//             strokeLinecap="round"
//             strokeLinejoin="round"
//             strokeWidth={2}
//             d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
//           />
//         </svg>
//       ),
//     },
//     failed: {
//       title: "KYC verification failed",
//       description: "Please resubmit the documents to try again.",
//       bgColor: "bg-red-500",
//       textColor: "text-white",
//       icon: (
//         <svg
//           className="w-6 h-6"
//           fill="none"
//           stroke="currentColor"
//           viewBox="0 0 24 24"
//         >
//           <path
//             strokeLinecap="round"
//             strokeLinejoin="round"
//             strokeWidth={2}
//             d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
//           />
//         </svg>
//       ),
//     },
//   };

//   const config = statusConfig[status];

//   return (
//     <div
//       className={`${config.bgColor} ${config.textColor} rounded-lg p-4 flex items-start justify-between`}
//     >
//       <div className="flex-1">
//         <h3 className="font-semibold text-lg mb-1">{config.title}</h3>
//         <p className="text-sm opacity-90">{config.description}</p>
//       </div>
//       <div className="ml-4">{config.icon}</div>
//     </div>
//   );
// };

// // Main Profile Layout Component
// const ProfileLayout = () => {
//   const navigate = useNavigate();
//   const { user, jwt, deleteSession } = useAuth(); // Use your existing auth provider
//   const [kycStatus, setKycStatus] = useState("pending"); // pending, in-process, complete, failed
//   const [kycData, setKycData] = useState(null);
//   const [isLoading, setIsLoading] = useState(false);

//   // Fetch KYC status using your existing API
//   const fetchKYCStatus = async () => {
//     try {
//       setIsLoading(true);
//       const response = await APICall(
//         "GET",
//         paths.user.kycStatus,
//         undefined,
//         undefined,
//         jwt
//       );

//       if (response && response.status === "success") {
//         setKycData(response);
//         setKycStatus(response.kyc_status || "pending");
//       }
//     } catch (error) {
//       console.error("Error fetching KYC status:", error);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (jwt && user) {
//       fetchKYCStatus();
//     }
//   }, [jwt, user]);

//   const handleEditProfile = () => {
//     navigate("/profile/edit");
//   };

//   const handleAccountPress = () => {
//     navigate("/profile/account");
//   };

//   const handleNotificationPress = () => {
//     navigate("/profile/notifications");
//   };

//   const handleSettingsPress = () => {
//     navigate("/profile/settings");
//   };

//   const handleHelpSupportPress = () => {
//     navigate("/profile/help-support");
//   };

//   const handlePaymentPress = () => {
//     navigate("/profile/payments");
//   };

//   const handlePrivacyPolicyPress = () => {
//     navigate("/privacy-policy");
//   };

//   const handleTermsConditionsPress = () => {
//     navigate("/profile/terms-conditions");
//   };

//   const handleLogout = async () => {
//     try {
//       setIsLoading(true);

//       // Use your existing APICall pattern for logout
//       const response = await APICall(
//         "PUT",
//         paths.user.logout,
//         user?.entity_id,
//         undefined,
//         jwt
//       );

//       if (response && response.status === "success") {
//         // Clear cookies using js-cookie (matching your existing pattern)
//         Cookies.remove("jwtToken", { path: "/" });
//         Cookies.remove("user_entity_id", { path: "/" });
//         Cookies.remove("appSettings", { path: "/" });

//         // Use your existing deleteSession function
//         deleteSession();

//         // Clear localStorage if needed
//         localStorage.clear();

//         // Navigate to auth page
//         navigate("/auth");
//       } else {
//         throw new Error(response?.message || "Logout failed");
//       }
//     } catch (error) {
//       console.error("Logout error:", error);
//       // You might want to show an error toast here
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   return (
//     <div className="min-h-screen bg-gray-50">
//       <div className="max-w-4xl mx-auto">
//         {/* Header Section */}
//         <div className="bg-white rounded-lg shadow-sm mb-6 p-6">
//           {/* User Profile Section */}
//           <div className="bg-blue-600 rounded-lg p-6 mb-4">
//             <div className="flex items-center justify-between">
//               <div className="flex items-center space-x-4">
//                 <div className="w-16 h-16 rounded-full bg-white/20 flex items-center justify-center overflow-hidden">
//                   {user?.media?.profile_picture?.location ? (
//                     <img
//                       src={user.media.profile_picture.location}
//                       alt="Profile"
//                       className="w-full h-full object-cover"
//                     />
//                   ) : (
//                     <svg
//                       className="w-8 h-8 text-white"
//                       fill="none"
//                       stroke="currentColor"
//                       viewBox="0 0 24 24"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
//                       />
//                     </svg>
//                   )}
//                 </div>
//                 <div className="text-white">
//                   <h2 className="text-xl font-semibold">
//                     {user?.first_name} {user?.last_name}
//                   </h2>
//                   <p className="text-blue-100">{user?.mobile}</p>
//                 </div>
//               </div>
//               <button
//                 onClick={handleEditProfile}
//                 className="px-4 py-2 border border-white/30 rounded-full text-white text-sm hover:bg-white/10 transition-colors"
//               >
//                 Edit
//               </button>
//             </div>
//           </div>

//           {/* KYC Status Card */}
//           <KYCStatusCard status={kycStatus} />
//         </div>

//         {/* Menu Options */}
//         <div className="bg-white rounded-lg shadow-sm mb-6">
//           <div className="p-6 space-y-2">
//             <ProfileOption
//               icon={
//                 <svg
//                   className="w-5 h-5"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
//                   />
//                 </svg>
//               }
//               title="Account"
//               onClick={handleAccountPress}
//             />

//             <ProfileOption
//               icon={
//                 <svg
//                   className="w-5 h-5"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M15 17h5l-5 5v-5zM9 9v6m0 0v6m0-6h6m6 0a9 9 0 11-18 0 9 9 0 0118 0z"
//                   />
//                 </svg>
//               }
//               title="Notifications"
//               onClick={handleNotificationPress}
//             />

//             <ProfileOption
//               icon={
//                 <svg
//                   className="w-5 h-5"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
//                   />
//                 </svg>
//               }
//               title="Payments"
//               onClick={handlePaymentPress}
//             />

//             <ProfileOption
//               icon={
//                 <svg
//                   className="w-5 h-5"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
//                   />
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
//                   />
//                 </svg>
//               }
//               title="Settings"
//               onClick={handleSettingsPress}
//             />

//             <ProfileOption
//               icon={
//                 <svg
//                   className="w-5 h-5"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
//                   />
//                 </svg>
//               }
//               title="Help & Support"
//               onClick={handleHelpSupportPress}
//             />
//           </div>
//         </div>

//         {/* Footer Section */}
//         <div className="bg-white rounded-lg shadow-sm p-6 space-y-4">
//           <button
//             onClick={handlePrivacyPolicyPress}
//             className="block w-full text-left text-gray-600 hover:text-gray-900 py-2"
//           >
//             Privacy Policy
//           </button>

//           <button
//             onClick={handleTermsConditionsPress}
//             className="block w-full text-left text-gray-600 hover:text-gray-900 py-2"
//           >
//             Terms & Conditions
//           </button>

//           <div className="flex items-center justify-between pt-4 border-t border-gray-200">
//             <button
//               onClick={handleLogout}
//               disabled={isLoading}
//               className="text-red-600 hover:text-red-700 font-medium disabled:opacity-50"
//             >
//               {isLoading ? "Logging out..." : "Logout"}
//             </button>
//             <span className="text-sm text-gray-500">App Version: 1.0.0</span>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ProfileLayout;

// ProfileLayout.js - Main Profile Layout Component using existing implementation
// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { useAuth } from "../../Utility/AuthProvider"; // Your existing auth provider
// import APICall from "../../Utility/APICall"; // Your existing API call function
// import { paths } from "../../Utility/Constants"; // Your existing paths
// import Cookies from "js-cookie"; // Your existing cookie library

// // Profile option component
// const ProfileOption = ({
//   icon,
//   title,
//   description,
//   onClick,
//   showChevron = true,
// }) => {
//   return (
//     <button
//       onClick={onClick}
//       className="w-full flex items-center justify-between p-4 hover:bg-gray-50 rounded-lg transition-colors group"
//     >
//       <div className="flex items-center space-x-4">
//         <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center text-blue-600">
//           {icon}
//         </div>
//         <div className="text-left">
//           <h3 className="text-base font-medium text-gray-900">{title}</h3>
//           {description && (
//             <p className="text-sm text-gray-500">{description}</p>
//           )}
//         </div>
//       </div>
//       {showChevron && (
//         <svg
//           className="w-5 h-5 text-gray-400 group-hover:text-gray-600"
//           fill="none"
//           stroke="currentColor"
//           viewBox="0 0 24 24"
//         >
//           <path
//             strokeLinecap="round"
//             strokeLinejoin="round"
//             strokeWidth={2}
//             d="M9 5l7 7-7 7"
//           />
//         </svg>
//       )}
//     </button>
//   );
// };

// // KYC Status Component
// const KYCStatusCard = ({ status = "pending" }) => {
//   const statusConfig = {
//     pending: {
//       title: "Your payout settings are pending",
//       description: "Complete to start receiving payments",
//       bgColor: "bg-yellow-500",
//       textColor: "text-white",
//       icon: (
//         <svg
//           className="w-6 h-6"
//           fill="none"
//           stroke="currentColor"
//           viewBox="0 0 24 24"
//         >
//           <path
//             strokeLinecap="round"
//             strokeLinejoin="round"
//             strokeWidth={2}
//             d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
//           />
//         </svg>
//       ),
//     },
//     "in-process": {
//       title: "KYC verification under process...",
//       description: "We'll update you when it's done",
//       bgColor: "bg-blue-500",
//       textColor: "text-white",
//       icon: (
//         <svg
//           className="w-6 h-6"
//           fill="none"
//           stroke="currentColor"
//           viewBox="0 0 24 24"
//         >
//           <path
//             strokeLinecap="round"
//             strokeLinejoin="round"
//             strokeWidth={2}
//             d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
//           />
//         </svg>
//       ),
//     },
//     complete: {
//       title: "KYC verification complete",
//       description: "You can now receive payments",
//       bgColor: "bg-green-500",
//       textColor: "text-white",
//       icon: (
//         <svg
//           className="w-6 h-6"
//           fill="none"
//           stroke="currentColor"
//           viewBox="0 0 24 24"
//         >
//           <path
//             strokeLinecap="round"
//             strokeLinejoin="round"
//             strokeWidth={2}
//             d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
//           />
//         </svg>
//       ),
//     },
//     failed: {
//       title: "KYC verification failed",
//       description: "Please resubmit the documents to try again.",
//       bgColor: "bg-red-500",
//       textColor: "text-white",
//       icon: (
//         <svg
//           className="w-6 h-6"
//           fill="none"
//           stroke="currentColor"
//           viewBox="0 0 24 24"
//         >
//           <path
//             strokeLinecap="round"
//             strokeLinejoin="round"
//             strokeWidth={2}
//             d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
//           />
//         </svg>
//       ),
//     },
//   };

//   const config = statusConfig[status];

//   return (
//     <div
//       className={`${config.bgColor} ${config.textColor} rounded-lg p-4 flex items-start justify-between`}
//     >
//       <div className="flex-1">
//         <h3 className="font-semibold text-lg mb-1">{config.title}</h3>
//         <p className="text-sm opacity-90">{config.description}</p>
//       </div>
//       <div className="ml-4">{config.icon}</div>
//     </div>
//   );
// };

// console.log("✅ ProfileLayout rendered!");

// // Main Profile Layout Component
// const ProfileLayout = () => {
//   const navigate = useNavigate();
//   const { user, jwt, deleteSession } = useAuth(); // Use your existing auth provider
//   const [kycStatus, setKycStatus] = useState("pending"); // pending, in-process, complete, failed
//   const [kycData, setKycData] = useState(null);
//   const [isLoading, setIsLoading] = useState(false);

//   // Fetch KYC status using your existing API
//   const fetchKYCStatus = async () => {
//     try {
//       setIsLoading(true);
//       const response = await APICall(
//         "GET",
//         paths.user.kycStatus,
//         undefined,
//         undefined,
//         jwt
//       );

//       if (response && response.status === "success") {
//         setKycData(response);
//         setKycStatus(response.kyc_status || "pending");
//       }
//     } catch (error) {
//       console.error("Error fetching KYC status:", error);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (jwt && user) {
//       fetchKYCStatus();
//     }
//   }, [jwt, user]);

//   const handleEditProfile = () => {
//     navigate("/profile/edit");
//   };

//   const handleAccountPress = () => {
//     navigate("/dashboard/profile/account");
//   };

//   const handleNotificationPress = () => {
//     navigate("/dashboard/profile/notifications");
//   };

//   const handleSettingsPress = () => {
//     navigate("/dashboard/profile/settings");
//   };

//   const handleHelpSupportPress = () => {
//     navigate("/dashboard/profile/help-support");
//   };

//   const handlePaymentPress = () => {
//     navigate("/dashboard/profile/payments");
//   };

//   const handlePrivacyPolicyPress = () => {
//     navigate("/privacy-policy");
//   };

//   const handleTermsConditionsPress = () => {
//     navigate("/dashboard/profile/terms-conditions");
//   };

//   const handleLogout = async () => {
//     try {
//       setIsLoading(true);

//       // Use your existing APICall pattern for logout
//       const response = await APICall(
//         "PUT",
//         paths.user.logout,
//         user?.entity_id,
//         undefined,
//         jwt
//       );

//       if (response && response.status === "success") {
//         // Clear cookies using js-cookie (matching your existing pattern)
//         Cookies.remove("jwtToken", { path: "/" });
//         Cookies.remove("user_entity_id", { path: "/" });
//         Cookies.remove("appSettings", { path: "/" });

//         // Use your existing deleteSession function
//         deleteSession();

//         // Clear localStorage if needed
//         localStorage.clear();

//         // Navigate to auth page
//         navigate("/auth");
//       } else {
//         throw new Error(response?.message || "Logout failed");
//       }
//     } catch (error) {
//       console.error("Logout error:", error);
//       // You might want to show an error toast here
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   return (
//     <div className="min-h-screen bg-gray-50">
//       <div className="max-w-4xl mx-auto">
//         {/* Header Section */}
//         <div className="bg-white rounded-lg shadow-sm mb-6 p-6">
//           {/* User Profile Section */}
//           <div className="bg-blue-600 rounded-lg p-6 mb-4">
//             <div className="flex items-center justify-between">
//               <div className="flex items-center space-x-4">
//                 <div className="w-16 h-16 rounded-full bg-white/20 flex items-center justify-center overflow-hidden">
//                   {user?.media?.profile_picture?.location ? (
//                     <img
//                       src={user.media.profile_picture.location}
//                       alt="Profile"
//                       className="w-full h-full object-cover"
//                     />
//                   ) : (
//                     <svg
//                       className="w-8 h-8 text-white"
//                       fill="none"
//                       stroke="currentColor"
//                       viewBox="0 0 24 24"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
//                       />
//                     </svg>
//                   )}
//                 </div>
//                 <div className="text-white">
//                   <h2 className="text-xl font-semibold">
//                     {user?.first_name} {user?.last_name}
//                   </h2>
//                   <p className="text-blue-100">{user?.mobile}</p>
//                 </div>
//               </div>
//               <button
//                 onClick={handleEditProfile}
//                 className="px-4 py-2 border border-white/30 rounded-full text-white text-sm hover:bg-white/10 transition-colors"
//               >
//                 Edit
//               </button>
//             </div>
//           </div>

//           {/* KYC Status Card */}
//           <KYCStatusCard status={kycStatus} />
//         </div>

//         {/* Menu Options */}
//         <div className="bg-white rounded-lg shadow-sm mb-6">
//           <div className="p-6 space-y-2">
//             <ProfileOption
//               icon={
//                 <svg
//                   className="w-5 h-5"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
//                   />
//                 </svg>
//               }
//               title="Account"
//               onClick={handleAccountPress}
//             />

//             <ProfileOption
//               icon={
//                 <svg
//                   className="w-5 h-5"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M15 17h5l-5 5v-5zM9 9v6m0 0v6m0-6h6m6 0a9 9 0 11-18 0 9 9 0 0118 0z"
//                   />
//                 </svg>
//               }
//               title="Notifications"
//               onClick={handleNotificationPress}
//             />

//             <ProfileOption
//               icon={
//                 <svg
//                   className="w-5 h-5"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
//                   />
//                 </svg>
//               }
//               title="Payments"
//               onClick={handlePaymentPress}
//             />

//             <ProfileOption
//               icon={
//                 <svg
//                   className="w-5 h-5"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
//                   />
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
//                   />
//                 </svg>
//               }
//               title="Settings"
//               onClick={handleSettingsPress}
//             />

//             <ProfileOption
//               icon={
//                 <svg
//                   className="w-5 h-5"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
//                   />
//                 </svg>
//               }
//               title="Help & Support"
//               onClick={handleHelpSupportPress}
//             />
//           </div>
//         </div>

//         {/* Footer Section */}
//         <div className="bg-white rounded-lg shadow-sm p-6 space-y-4">
//           <button
//             onClick={handlePrivacyPolicyPress}
//             className="block w-full text-left text-gray-600 hover:text-gray-900 py-2"
//           >
//             Privacy Policy
//           </button>

//           <button
//             onClick={handleTermsConditionsPress}
//             className="block w-full text-left text-gray-600 hover:text-gray-900 py-2"
//           >
//             Terms & Conditions
//           </button>

//           <div className="flex items-center justify-between pt-4 border-t border-gray-200">
//             <button
//               onClick={handleLogout}
//               disabled={isLoading}
//               className="text-red-600 hover:text-red-700 font-medium disabled:opacity-50"
//             >
//               {isLoading ? "Logging out..." : "Logout"}
//             </button>
//             <span className="text-sm text-gray-500">App Version: 1.0.0</span>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ProfileLayout;

// Enhanced ProfileLayout.js with KYC and Edit functionality debugging
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../Utility/AuthProvider";
import APICall from "../../Utility/APICall";
import { paths } from "../../Utility/Constants";
import Cookies from "js-cookie";
import { useSettings, useUpdateSettings } from "../../Contexts/SettingsContext";
import CustomImage, { IMAGE_TYPES } from "../../Utility/CustomImage";

// Enhanced Profile option component
const ProfileOption = ({
  icon,
  title,
  description,
  onClick,
  showChevron = true,
  className = "",
}) => {
  return (
    <button
      onClick={onClick}
      className={`w-full flex items-center justify-between p-4 hover:bg-blue-50 rounded-lg transition-all duration-200 group border border-transparent hover:border-blue-200 ${className}`}
    >
      <div className="flex items-center space-x-4">
        <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center text-blue-600 group-hover:bg-blue-200 transition-colors">
          {icon}
        </div>
        <div className="text-left">
          <h3 className="text-base font-semibold text-gray-900">{title}</h3>
          {description && (
            <p className="text-sm text-gray-500">{description}</p>
          )}
        </div>
      </div>
      {showChevron && (
        <svg
          className="w-5 h-5 text-gray-400 group-hover:text-blue-600 transition-colors"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 5l7 7-7 7"
          />
        </svg>
      )}
    </button>
  );
};

// Quick Settings Toggle Component
const QuickSettingsToggle = ({ label, isActive, onToggle }) => {
  return (
    <div className="flex items-center justify-between py-2">
      <span className="text-sm font-medium text-gray-700">{label}</span>
      <button
        onClick={onToggle}
        className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${
          isActive ? "bg-blue-600" : "bg-gray-300"
        }`}
      >
        <span
          className={`inline-block h-3 w-3 transform rounded-full bg-white transition-transform ${
            isActive ? "translate-x-5" : "translate-x-1"
          }`}
        />
      </button>
    </div>
  );
};

// Enhanced KYC Status Component with debugging
const KYCStatusCard = ({
  status = "pending",
  data = null,
  onClick,
  isLoading = false,
}) => {
  console.log("🔍 KYC Status Card - Status:", status, "Data:", data);

  if (isLoading) {
    return (
      <div className="bg-gray-100 rounded-xl p-5 flex items-center justify-center">
        <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600"></div>
        <span className="ml-3 text-gray-600">Loading KYC status...</span>
      </div>
    );
  }

  const statusConfig = {
    pending: {
      title: "Your payout settings are pending",
      description: "Complete to start receiving payments",
      bgColor: "bg-gradient-to-r from-yellow-500 to-orange-500",
      textColor: "text-white",
      showCard: true,
      icon: (
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      ),
    },
    "in-process": {
      title: "KYC verification under process...",
      description: "We'll update you when it's done",
      bgColor: "bg-gradient-to-r from-blue-500 to-indigo-600",
      textColor: "text-white",
      showCard: true,
      icon: (
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      ),
    },
    complete: {
      title: "KYC verification complete",
      description: "You can now receive payments",
      bgColor: "bg-gradient-to-r from-green-500 to-emerald-600",
      textColor: "text-white",
      showCard: true,
      icon: (
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      ),
    },
    failed: {
      title: "KYC verification failed",
      description: data?.remarks
        ? `Reason: ${data.remarks}`
        : "Please resubmit the documents to try again.",
      bgColor: "bg-gradient-to-r from-red-500 to-pink-600",
      textColor: "text-white",
      showCard: true,
      icon: (
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      ),
    },
    none: {
      title: "Complete your KYC verification",
      description: "Set up your payout settings to start receiving payments",
      bgColor: "bg-gradient-to-r from-gray-500 to-gray-600",
      textColor: "text-white",
      showCard: true,
      icon: (
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 6v6m0 0v6m0-6h6m-6 0H6"
          />
        </svg>
      ),
    },
  };

  const config = statusConfig[status] || statusConfig.none;

  // Don't show KYC card if show_kyc_prompt is false and status is complete
  if (status === "complete" && data?.show_kyc_prompt === false) {
    console.log("🚫 Hiding KYC card due to show_kyc_prompt = false");
    return null;
  }

  if (!config.showCard) {
    return null;
  }

  return (
    <div
      onClick={onClick}
      className={`${config.bgColor} ${config.textColor} rounded-xl p-5 flex items-start justify-between cursor-pointer hover:scale-105 transition-transform duration-200 shadow-lg`}
    >
      <div className="flex-1">
        <h3 className="font-semibold text-lg mb-1">{config.title}</h3>
        <p className="text-sm opacity-90">{config.description}</p>
      </div>
      <div className="ml-4">{config.icon}</div>
    </div>
  );
};

// Main Profile Layout Component
const ProfileLayout = () => {
  const navigate = useNavigate();
  const { user, jwt, deleteSession } = useAuth();
  const settings = useSettings();
  const updateSettings = useUpdateSettings();

  // Enhanced state with better debugging
  const [kycStatus, setKycStatus] = useState("pending");
  const [kycData, setKycData] = useState(null);
  const [isKycLoading, setIsKycLoading] = useState(true);
  const [kycError, setKycError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  // Debug user data
  console.log("🔍 ProfileLayout Debug:");
  console.log("User:", user);
  console.log("JWT:", jwt ? "Present" : "Missing");
  console.log("Settings:", settings);

  // Mock AppSettings if not available
  const AppSettings = {
    ALLOW_HAPTIC_FEEDBACK: "allowHapticFeedback",
    SHOW_TAB_NAMES: "showTabNames",
    SHOW_FUTURE_REPORTS: "showFutureReports",
    getDefaultValue: (setting) => {
      const defaults = {
        allowHapticFeedback: true,
        showTabNames: true,
        showFutureReports: true,
      };
      return defaults[setting] || false;
    },
  };

  // Enhanced KYC status fetching with debugging
  const fetchKYCStatus = async () => {
    console.log("🔄 Fetching KYC status...");

    if (!jwt || !user) {
      console.log("❌ Cannot fetch KYC: Missing JWT or user");
      setIsKycLoading(false);
      return;
    }

    try {
      setIsKycLoading(true);
      setKycError(null);

      console.log("📡 Making KYC API call to:", paths.user.kycStatus);
      const response = await APICall(
        "GET",
        paths.user.kycStatus,
        undefined,
        undefined,
        jwt
      );

      console.log("📥 KYC API Response:", response);

      if (response && response.status === "success") {
        setKycData(response);
        setKycStatus(response.kyc_status || "none");
        console.log("✅ KYC Status set to:", response.kyc_status);
      } else {
        console.log("⚠️ KYC API call unsuccessful:", response);
        setKycError("Failed to fetch KYC status");
        setKycStatus("none");
      }
    } catch (error) {
      console.error("❌ Error fetching KYC status:", error);
      setKycError(error.message);
      setKycStatus("none");
    } finally {
      setIsKycLoading(false);
    }
  };

  useEffect(() => {
    console.log("📍 useEffect triggered - fetching KYC");
    fetchKYCStatus();
  }, [jwt, user]);

  // Enhanced navigation handlers with debugging
  const handleEditProfile = () => {
    console.log("🔧 Edit Profile clicked");
    console.log("Navigating to: /dashboard/profile/account");
    navigate("/dashboard/profile/account");
  };

  const handleAccountPress = () => {
    console.log("👤 Account button clicked");
    console.log("Navigating to: /dashboard/profile/account");
    navigate("/dashboard/profile/account");
  };

  const handleNotificationPress = () => {
    console.log("🔔 Notifications button clicked");
    navigate("/dashboard/profile/notifications");
  };

  const handleSettingsPress = () => {
    console.log("⚙️ Settings button clicked");
    navigate("/dashboard/profile/settings");
  };

  const handleHelpSupportPress = () => {
    console.log("❓ Help & Support button clicked");
    navigate("/dashboard/profile/help-support");
  };

  const handlePaymentPress = () => {
    console.log("💳 Payments button clicked");
    navigate("/dashboard/profile/payments");
  };

  const handleKYCClick = () => {
    console.log("🏦 KYC card clicked - navigating to payments");
    navigate("/dashboard/profile/payments");
  };

  // Quick settings handlers
  const getSettingsValue = (property) => {
    const value =
      settings?.[property] === undefined
        ? AppSettings.getDefaultValue(property)
        : settings[property];
    console.log(`⚙️ Setting ${property}:`, value);
    return value;
  };

  const handleQuickToggle = (property) => {
    const newValue = !getSettingsValue(property);
    console.log(`🔄 Toggling ${property} to:`, newValue);
    updateSettings({ [property]: newValue });
  };

  const handleLogout = async () => {
    try {
      setIsLoading(true);
      console.log("🚪 Logout initiated");

      const response = await APICall(
        "PUT",
        paths.user.logout,
        user?.entity_id,
        undefined,
        jwt
      );

      if (response && response.status === "success") {
        console.log("✅ Logout successful");
        Cookies.remove("jwtToken", { path: "/" });
        Cookies.remove("user_entity_id", { path: "/" });
        Cookies.remove("appSettings", { path: "/" });
        deleteSession();
        localStorage.clear();
        navigate("/auth");
      } else {
        throw new Error(response?.message || "Logout failed");
      }
    } catch (error) {
      console.error("❌ Logout error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // Loading state
  if (!user) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading profile...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-5xl mx-auto p-6">
        {/* Debug Info (Remove in production) */}
        {/* <div className="bg-yellow-100 border border-yellow-400 rounded-lg p-4 mb-6">
          <h4 className="font-semibold text-yellow-800">Debug Info:</h4>
          <p className="text-sm text-yellow-700">
            User: {user?.first_name} | KYC Status: {kycStatus} | Loading:{" "}
            {isKycLoading ? "Yes" : "No"}
          </p>
          {kycError && (
            <p className="text-sm text-red-600">KYC Error: {kycError}</p>
          )}
        </div> */}

        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            Profile Settings
          </h1>
          <p className="text-gray-600">
            Manage your account, preferences, and app settings
          </p>
        </div>

        {/* User Profile Card */}
        <div className="bg-white rounded-xl shadow-sm mb-8 overflow-hidden">
          <div className="bg-gradient-to-r from-blue-600 to-indigo-700 p-6">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-4">
                {/* <div className="w-20 h-20 rounded-full bg-white/20 flex items-center justify-center overflow-hidden border-4 border-white/30">
                  {user?.media?.profile_picture?.location ? (
                    <img
                      src={user.media.profile_picture.location}
                      alt="Profile"
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <svg
                      className="w-10 h-10 text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                      />
                    </svg>
                  )}
                </div> */}
                <CustomImage
                  location={user?.media?.profile_picture?.location}
                  className="w-20 h-20 rounded-full"
                  imageType={IMAGE_TYPES.PROFILE}
                  altText="Profile picture"
                />
                <div className="text-white">
                  <h2 className="text-2xl font-semibold">
                    {user?.first_name} {user?.last_name}
                  </h2>
                  <p className="text-blue-100 text-lg">{user?.mobile}</p>
                  <p className="text-blue-200 text-sm">{user?.email}</p>
                </div>
              </div>
              <button
                onClick={handleEditProfile}
                className="px-6 py-2 border-2 border-white/30 rounded-full text-white text-sm hover:bg-white/10 transition-colors font-medium"
              >
                Edit Profile
              </button>
            </div>
          </div>

          {/* KYC Status Card */}
          {/* <div className="p-6">
            <KYCStatusCard
              status={kycStatus}
              data={kycData}
              onClick={handleKYCClick}
              isLoading={isKycLoading}
            />
          </div> */}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Main Menu Options */}
          <div className="lg:col-span-2">
            <div className="bg-white rounded-xl shadow-sm p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-6">
                Settings & Preferences
              </h3>
              <div className="space-y-3">
                <ProfileOption
                  icon={
                    <svg
                      className="w-6 h-6"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                      />
                    </svg>
                  }
                  title="Account Settings"
                  description="Manage your personal information and security"
                  onClick={handleAccountPress}
                />

                <ProfileOption
                  icon={
                    <svg
                      className="w-6 h-6"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M15 17h5l-5 5v-5zM9 9v6m0 0v6m0-6h6m6 0a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                  }
                  title="Notifications"
                  description="Control how you receive updates and alerts"
                  onClick={handleNotificationPress}
                />

                {/* <ProfileOption
                  icon={
                    <svg
                      className="w-6 h-6"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
                      />
                    </svg>
                  }
                  title="Payments & KYC"
                  description="Manage payment methods and verification"
                  onClick={handlePaymentPress}
                /> */}

                <ProfileOption
                  icon={
                    <svg
                      className="w-6 h-6"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
                      />
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                      />
                    </svg>
                  }
                  title="App Settings"
                  description="Customize app behavior and preferences"
                  onClick={handleSettingsPress}
                />

                <ProfileOption
                  icon={
                    <svg
                      className="w-6 h-6"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                  }
                  title="Help & Support"
                  description="Get help and contact support"
                  onClick={handleHelpSupportPress}
                />
              </div>
            </div>
          </div>

          {/* Quick Settings Panel */}
          <div className="space-y-6">
            {/* Quick Settings */}
            <div className="bg-white rounded-xl shadow-sm p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">
                Quick Settings
              </h3>
              <div className="space-y-3">
                {/* <QuickSettingsToggle
                  label="Haptic Feedback"
                  isActive={getSettingsValue(AppSettings.ALLOW_HAPTIC_FEEDBACK)}
                  onToggle={() =>
                    handleQuickToggle(AppSettings.ALLOW_HAPTIC_FEEDBACK)
                  }
                /> */}
                <QuickSettingsToggle
                  label="Show Tab Names"
                  isActive={getSettingsValue(AppSettings.SHOW_TAB_NAMES)}
                  onToggle={() => handleQuickToggle(AppSettings.SHOW_TAB_NAMES)}
                />
                <QuickSettingsToggle
                  label="Future Reports"
                  isActive={getSettingsValue(AppSettings.SHOW_FUTURE_REPORTS)}
                  onToggle={() =>
                    handleQuickToggle(AppSettings.SHOW_FUTURE_REPORTS)
                  }
                />
              </div>
              <button
                onClick={handleSettingsPress}
                className="w-full mt-4 text-sm text-blue-600 hover:text-blue-700 font-medium"
              >
                View All Settings →
              </button>
            </div>

            {/* App Info */}
            <div className="bg-white rounded-xl shadow-sm p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">
                App Information
              </h3>
              <div className="space-y-3 text-sm">
                <div className="flex justify-between">
                  <span className="text-gray-600">Version</span>
                  <span className="font-medium">1.0.0</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">Last Updated</span>
                  <span className="font-medium">Today</span>
                </div>
              </div>
            </div>

            {/* Logout Button */}
            <button
              onClick={handleLogout}
              disabled={isLoading}
              className="w-full bg-red-600 hover:bg-red-700 text-white font-semibold py-3 px-4 rounded-xl transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isLoading ? "Signing Out..." : "Sign Out"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileLayout;
